import { jsx as _jsx } from "react/jsx-runtime";
import { Notification, } from './notification.component';
export const InlineNotification = (props) => (_jsx(Notification, Object.assign({}, props, { variant: 'inline', closeable: false })));
//# sourceMappingURL=notification_inline.component.js.map